<template>
    <b-dropdown
        id="btn-dropdown-nbox-select-to-see"
        variant="primary"
        class="mb-3"
    >
        <template slot="button-content">
            <i class="fas fa-th mr-2" />
            <span class="mr-2">{{ $t('nBox.visualizeNBox') }}</span>
        </template>
        <template>
            <div class="dropdown-content">
                <div v-if="hasNBoxes">
                    <b-form-checkbox-group
                        stacked
                        :value="selected"
                        @change="$emit('change', $event)"
                    >
                        <div
                            class="d-flex"
                            :key="nBox.id"
                            v-for="nBox in nBoxes"
                        >
                            <b-form-checkbox
                                :value="nBox.id"
                                :disabled="nBox.isLoading"
                            />
                            <div class="d-flex">
                                <span class="mr-2">
                                    {{ nBox.title }}
                                </span>
                                <b-spinner
                                    v-if="nBox.isLoading"
                                    small
                                    variant="primary"
                                />
                            </div>
                        </div>
                    </b-form-checkbox-group>
                </div>
                <div
                    v-else
                    class="d-flex flex-column justify-content-center align-items-center text-muted"
                >
                    <span class="text-center font-weight-bold mb-2">{{
                        $t('nBox.noNBoxRegistered')
                    }}</span>
                    <b-button
                        size="sm"
                        variant="primary"
                        style="max-width: 150px"
                        @click="$emit('create-n-box')"
                        >{{ $t('nBox.createNewNBox') }}</b-button
                    >
                </div>
            </div>
        </template>
    </b-dropdown>
</template>
<script>
export default {
    props: {
        selected: Array,
        hasNBoxes: Boolean,
        nBoxes: [Array, Object],
    },
}
</script>
<style lang="scss" scoped>
.dropdown-content {
    padding: 8px;
    width: 400px;
}

::v-deep
    .custom-checkbox
    .custom-control-input:checked
    ~ .custom-control-label::after {
    background-image: none;
}
</style>
